import ApiService from '@/common/api.service'
import {
  CREATE_LIVE_STREAM,
  UPDATE_LIVE_STREAM,
  GET_LIVE_STREAMS,
  GET_CURRENT_LIVE_STREAMS,
  GET_LIVE_STREAM,
  UPDATE_LIVE_STREAM_STATUS,
  ADD_FAKE_VIEWERS,
  CREATE_POLL_QUESTION,
  UPDATE_POLL_QUESTION,
  DELETE_POLL_QUESTION,
  RESET_LIVE_STREAM_STATE,
  EXPORT_POLL,
  GET_WOWZA_STATUS,
  DELETE_LIVE_STREAM,
  INVALIDATE_STREAM
} from './actions.type'

import {
  SET_ERROR,
  SET_CREATED_LIVE_STREAM,
  SET_LIVE_STREAMS,
  SET_CURRENT_LIVE_STREAMS,
  SET_LIVE_STREAM,
  SET_FAKE_VIEWERS,
  SET_IS_LOADING,
  SET_POLL_QUESTION,
  SET_UPDATED_LIVE_STREAM_STATUS,
  RESET_STATE
} from './mutations.type'
import Progress from '@/common/progress'
// import { formatViewers } from '@/common/utils'

export const getDefaultState = () => {
  return {
    liveStreams: null,
    currentLiveStreams: null,
    currentLiveStream: null,
    displayViewCount: 0,
    pinnedComment: null,
    pollQuestion: null,
    pollResult: null,
    isLoading: false,
    totalPage: null,
    totalCurrentLiveStream: 0,
    error: null
  }
}

const state = getDefaultState()

const getters = {
  totalLiveStreamPage(state) {
    return state.totalPage
  },
  liveStreams(state) {
    return state.liveStreams
  },
  currentLiveStreams(state) {
    return state.currentLiveStreams
  },
  currentLiveStream(state) {
    return state.currentLiveStream
  },
  displayViewCount(state) {
    return state.displayViewCount
  },
  pinnedComment(state) {
    return state.pinnedComment
  }

}

const actions = {
  [CREATE_LIVE_STREAM](context, liveStream) {
    Progress.show()
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.post('api/v1/streamings', liveStream)
        .then(({ data }) => {
          Progress.hide()
          context.commit(SET_CREATED_LIVE_STREAM, data)
          resolve(data)
        })
        .catch(({ response }) => {
          Progress.hide()
          context.commit(SET_ERROR, response.data)
          reject(response)
        })
    })
  },
  [UPDATE_LIVE_STREAM](context, { id, title, description }) {
    Progress.show()
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.put(`api/v1/streamings/${id}`, { title: title, description: description })
        .then(({ data }) => {
          Progress.hide()
          context.commit(SET_LIVE_STREAM, { liveStreamResponse: data, isUpdated: true })
          resolve(data)
        }).catch(({ response }) => {
          Progress.hide()
          context.commit(SET_ERROR, response)
          reject(response.data)
        })
    })
  },
  [GET_LIVE_STREAMS](context, page) {
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.get('api/v1/streamings', '?limit=10&page=' + page)
        .then(({ data }) => {
          context.commit(SET_LIVE_STREAMS, data)
          resolve(data)
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response.data)
          reject(response)
        })
    })
  },
  [GET_CURRENT_LIVE_STREAMS](context) {
    return new Promise((resolve, reject) => {
      ApiService.get('api/v1/streamings/currentLiveStream')
        .then(({ data }) => {
          context.commit(SET_CURRENT_LIVE_STREAMS, data)
          resolve(data)
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response.data)
          reject(response.data)
        })
    })
  },
  [GET_LIVE_STREAM](context, slug) {
    return new Promise((resolve, reject) => {
      ApiService.get('api/v1/streamings', slug)
        .then(({ data }) => {
          context.commit(SET_LIVE_STREAM, { liveStreamResponse: data, isUpdated: false })
          resolve(data)
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response.data)
          reject(response.data)
        })
    })
  },
  [UPDATE_LIVE_STREAM_STATUS](context, { id, status }) {
    Progress.show()
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.put('api/v1/streamings/' + id + '/status', { status: status })
        .then(({ data }) => {
          Progress.hide()
          context.commit(SET_UPDATED_LIVE_STREAM_STATUS, data)
          resolve(data)
        }).catch(({ response }) => {
          Progress.hide()
          context.commit(SET_ERROR, response.data)
          reject(response.data)
        })
    })
  },
  async [DELETE_LIVE_STREAM](context, id) {
    context.commit(SET_IS_LOADING, true)
    try {
      const res = await ApiService.delete(`api/v1/streamings/${id}`)
      context.commit(SET_IS_LOADING, false)
      return res.data
    } catch ({ response }) {
      context.commit(SET_IS_LOADING, false)
      return response.data
    }
  },
  [GET_WOWZA_STATUS](context, id) {
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.get(`api/v1/streamings/${id}/status`)
        .then(({ data }) => {
          context.commit(SET_IS_LOADING, false)
          resolve(data)
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response.data)
          reject(response.data)
        })
    })
  },
  [ADD_FAKE_VIEWERS](context, { id, count }) {
    Progress.show()
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.post('api/v1/streamings/' + id + '/displayViews', { viewCount: count })
        .then(({ data }) => {
          Progress.hide()
          context.commit(SET_FAKE_VIEWERS, data)
          resolve(data)
        }).catch(({ response }) => {
          Progress.hide()
          context.commit(SET_ERROR, response.data)
          reject(response.data)
        })
    })
  },
  [CREATE_POLL_QUESTION](context, poll) {
    Progress.show()
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.post('api/v1/polls', poll)
        .then(({ data }) => {
          Progress.hide()
          context.commit(SET_POLL_QUESTION, { response: data, isUpdate: true })
          resolve(data)
        }).catch(({ response }) => {
          Progress.hide()
          context.commit(SET_ERROR, response.data)
          reject(response.data)
        })
    })
  },
  [UPDATE_POLL_QUESTION](context, poll) {
    Progress.show()
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.put(`api/v1/polls/${poll.id}`, poll)
        .then(({ data }) => {
          Progress.hide()
          context.commit(SET_POLL_QUESTION, { response: data, isUpdate: true })
          resolve(data)
        }).catch(({ response }) => {
          Progress.hide()
          context.commit(SET_ERROR, response.data)
          reject(response.data)
        })
    })
  },
  [DELETE_POLL_QUESTION](context, id) {
    Progress.show()
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.delete(`api/v1/streamings/${id}/poll`)
        .then(({ data }) => {
          resolve(data)
        }).catch(({ response }) => {
          Progress.hide()
          context.commit(SET_ERROR, response.data)
          reject(response.data)
        })
    })
  },
  [EXPORT_POLL](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.downloadFile(`api/v1/polls/${id}/exportPollResult`)
        .then(({ data }) => {
          resolve(data)
        }).catch(({ response }) => {
          reject(response.data)
        })
    })
  },
  [RESET_LIVE_STREAM_STATE](context) {
    context.commit(RESET_STATE)
  },
  async [INVALIDATE_STREAM](context, id) {
    try {
      const res = await ApiService.put(`socket/api/v1/streamings/invalidate/${id}`)
      return res.data
    } catch ({ response }) {
      return response.data
    }
  }
}

const mutations = {
  [SET_CREATED_LIVE_STREAM](state, liveStream) {
    state.error = null
    state.currentLiveStream = liveStream
    state.isLoading = false
  },
  [SET_LIVE_STREAMS](state, liveStreamResponse) {
    state.liveStreams = liveStreamResponse.data
    state.error = null
    if (liveStreamResponse.data.length > 0) {
      const liveStream = liveStreamResponse.data[0]
      if (liveStream.status === 'live' || liveStream.status === 'pending') {
        state.currentLiveStream = liveStream
      }
    }
    state.isLoading = false
    state.totalPage = liveStreamResponse.meta.lastPage
  },
  [SET_CURRENT_LIVE_STREAMS](state, liveStreamResponse) {
    state.currentLiveStreams = liveStreamResponse.data
    state.totalCurrentLiveStream = liveStreamResponse.meta.total
    state.error = null
  },
  [SET_LIVE_STREAM](state, { liveStreamResponse, isUpdated }) {
    if (!isUpdated) {
      state.currentLiveStream = liveStreamResponse.streaming
      state.pinnedComment = liveStreamResponse.streaming.pinComment
      state.displayViewCount = liveStreamResponse.streaming.displayViews
      state.pollQuestion = liveStreamResponse.streaming.poll
      state.pollResult = liveStreamResponse.pollResult
    } else {
      state.currentLiveStream = liveStreamResponse
      state.pinnedComment = liveStreamResponse.pinComment
      state.displayViewCount = liveStreamResponse.displayViews
      state.pollQuestion = liveStreamResponse.poll
    }
    state.isLoading = false
    state.error = null
  },
  [SET_FAKE_VIEWERS](state, response) {
    state.error = null
    state.isLoading = false
  },
  [SET_POLL_QUESTION](state, { response, isUpdate }) {
    var id
    if (isUpdate) {
      id = response.id
    } else {
      id = response.streaming.poll.id
    }
    state.pollQuestion = {
      id: id,
      question: response.question,
      answers: response.answers
    }
    state.isLoading = false
  },
  [SET_UPDATED_LIVE_STREAM_STATUS](state, response) {
    const streamer = state.currentLiveStream.streamer
    state.currentLiveStream = response
    state.currentLiveStream.streamer = streamer
    state.pinnedComment = null
    state.isLoading = false
  },
  [SET_ERROR](state, error) {
    state.error = error
    state.isLoading = false
  },
  [SET_IS_LOADING](state, isLoading) {
    state.isLoading = isLoading
  },
  [RESET_STATE](state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
